import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, ChevronLeft, ChevronRight } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const attUrl = (a) => `${BACKEND}${a.url}`;

export function AttachmentLightbox({ attachments = [], index, onClose }) {
  const [i, setI] = useState(index ?? 0);
  useEffect(() => { if (index !== null && index !== undefined) setI(index); }, [index]);

  if (index === null || index === undefined || !attachments.length) return null;
  const a = attachments[i];
  if (!a) return null;

  const go = (delta) => (e) => { e.stopPropagation(); setI((v) => (v + delta + attachments.length) % attachments.length); };

  const download = async () => {
    try {
      const res = await fetch(attUrl(a));
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url; link.download = a.filename || "allegato"; link.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download non riuscito"); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl gap-0 overflow-hidden p-0" data-testid="att-lightbox">
        <DialogTitle className="sr-only">{a.filename || "Allegato"}</DialogTitle>
        <DialogDescription className="sr-only">Anteprima allegato con possibilità di scaricare</DialogDescription>
        <div className="relative flex items-center justify-center bg-black">
          <img src={attUrl(a)} alt={a.filename} className="max-h-[75vh] w-full object-contain" data-testid="att-lightbox-img" />
          {attachments.length > 1 && (
            <>
              <button onClick={go(-1)} data-testid="att-lightbox-prev"
                className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/85 p-2 text-navy shadow transition-colors hover:bg-white"><ChevronLeft size={20} /></button>
              <button onClick={go(1)} data-testid="att-lightbox-next"
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/85 p-2 text-navy shadow transition-colors hover:bg-white"><ChevronRight size={20} /></button>
            </>
          )}
        </div>
        <div className="flex items-center justify-between gap-3 bg-card p-3">
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-navy">{a.filename || "Allegato"}</p>
            <p className="truncate text-xs text-muted-foreground">
              {[a.uploaded_by && `Caricato da ${a.uploaded_by}`, a.source === "checklist" && "Check-list", attachments.length > 1 && `${i + 1}/${attachments.length}`].filter(Boolean).join(" · ")}
            </p>
          </div>
          <Button size="sm" onClick={download} data-testid="att-lightbox-download"><Download size={15} />Scarica</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
